/* IndexedDB-backed offline write queue.
 *
 * Items are read & replayed by /service-worker.js when:
 *   - the browser fires `online`
 *   - a message {type: 'flush-queue'} is posted to the active SW
 *
 * Item shape (json):
 *   { id?, kind: 'json', url, method, body, headers? }
 *
 * Item shape (multipart photo upload):
 *   { id?, kind: 'multipart', url, method: 'POST', fileBlob: Blob, fileName, form: { kind, note? } }
 */

const DB = "ll-offline-queue";
const STORE = "writes";

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function enqueue(item) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    const req = tx.objectStore(STORE).add({ ...item, enqueued_at: Date.now() });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function listQueued() {
  const db = await open();
  return new Promise((resolve) => {
    const tx = db.transaction(STORE, "readonly");
    const out = [];
    const cursorReq = tx.objectStore(STORE).openCursor();
    cursorReq.onsuccess = (e) => {
      const cursor = e.target.result;
      if (cursor) { out.push(cursor.value); cursor.continue(); }
      else resolve(out);
    };
    cursorReq.onerror = () => resolve([]);
  });
}

export async function queueCount() {
  return (await listQueued()).length;
}

export async function flushNow() {
  if (!navigator.serviceWorker?.controller) return false;
  navigator.serviceWorker.controller.postMessage({ type: "flush-queue" });
  return true;
}

/** Try register a background sync; falls back to message-based flush on `online`. */
export async function requestSync() {
  try {
    const reg = await navigator.serviceWorker.ready;
    if ("sync" in reg) {
      await reg.sync.register("ll-flush-queue");
      return true;
    }
  } catch (_e) {}
  return false;
}
